import React from 'react';
import { ContextLayout } from '../../context-provider';
export default function IconCircleDisabled(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$useCurrentColo = props.useCurrentColor,
      useCurrentColor = _props$useCurrentColo === void 0 ? true : _props$useCurrentColo,
      style = props.style;
  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var prefixCls = _ref.prefixCls;
    return /*#__PURE__*/React.createElement("svg", {
      className: prefixCls + "-icon " + prefixCls + "-icon-circle-disabled " + className,
      width: "1em",
      height: "1em",
      style: style,
      viewBox: "0 0 20 20",
      fill: useCurrentColor ? "currentColor" : "#F7F8FA",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M18.375 10a8.375 8.375 0 11-16.75 0 8.375 8.375 0 0116.75 0z",
      stroke: "#E5E6EB",
      strokeWidth: "1.25"
    }));
  });
}